import BiblioPreview from '../../components/biblio/BiblioPreview'
import BiblioHistory from './BiblioHistory'

export default [{
  path: '/biblio/:biblio_id/preview/:project_id',
  name: 'BiblioPreview',
  component: BiblioPreview,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer'}
}, {
  path: '/biblio/:biblio_id/history',
  name: 'BiblioHistory',
  component: BiblioHistory,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'Biblio History', showNavigation: true}
}
]



// WEBPACK FOOTER //
// ./src/pages/biblio/router.js